import { gql } from '@/apollo';

const FEATURE_ACCESS_FIELDS = `
  canAdd
  canChange
  canDelete
`;

export const GET_USER_CUSTOMER_ACCESS = gql`
  query GetUserCustomerAccess($userId: ID!) {
    userCustomerAccess(userId: $userId) {
      canManageConditions
      grants {
        ${FEATURE_ACCESS_FIELDS}
        appointmentDetailsAccess {
          ${FEATURE_ACCESS_FIELDS}
        }
        customer {
          id
          name
          description
          isActive
        }
      }
    }
  }
`;

export const GET_MY_MODERATOR_PERMISSIONS = gql`
  query GetMyModeratorPermissions {
    myModeratorPermissions {
      canManageConditions
      grants {
        ${FEATURE_ACCESS_FIELDS}
        appointmentDetailsAccess {
          ${FEATURE_ACCESS_FIELDS}
        }
        customer {
          id
          name
        }
      }
    }
  }
`;

export const GRANT_USER_CUSTOMER_ACCESS = gql`
  mutation GrantUserCustomerAccess(
    $userId: ID!
    $customerId: ID!
    $permissions: CustomerAccessPermissionsInput
  ) {
    grantUserCustomerAccess(
      userId: $userId
      customerId: $customerId
      permissions: $permissions
    )
  }
`;

export const REVOKE_USER_CUSTOMER_ACCESS = gql`
  mutation RevokeUserCustomerAccess($userId: ID!, $customerId: ID!) {
    revokeUserCustomerAccess(userId: $userId, customerId: $customerId)
  }
`;

export const UPDATE_USER_CUSTOMER_ACCESS = gql`
  mutation UpdateUserCustomerAccess(
    $userId: ID!
    $customerId: ID!
    $permissions: CustomerAccessPermissionsInput!
  ) {
    updateUserCustomerAccess(
      userId: $userId
      customerId: $customerId
      permissions: $permissions
    )
  }
`;

export const UPDATE_USER_CONDITIONS_ACCESS = gql`
  mutation UpdateUserConditionsAccess($userId: ID!, $canManageConditions: Boolean!) {
    updateUserConditionsAccess(userId: $userId, canManageConditions: $canManageConditions)
  }
`;

export const SET_ALL_USER_CUSTOMER_ACCESS_PERMISSIONS = gql`
  mutation SetAllUserCustomerAccessPermissions(
    $userId: ID!
    $permissions: CustomerAccessPermissionsInput!
    $includeConditions: Boolean!
  ) {
    setAllUserCustomerAccessPermissions(
      userId: $userId
      permissions: $permissions
      includeConditions: $includeConditions
    )
  }
`;

export const GRANT_ALL_USER_CUSTOMER_ACCESS = gql`
  mutation GrantAllUserCustomerAccess($userId: ID!) {
    grantAllUserCustomerAccess(userId: $userId)
  }
`;

export const COPY_USER_CUSTOMER_ACCESS = gql`
  mutation CopyUserCustomerAccess($fromUserId: ID!, $toUserId: ID!) {
    copyUserCustomerAccess(fromUserId: $fromUserId, toUserId: $toUserId)
  }
`;
